import React from "react";
import { Link } from "react-router-dom";
import userimg from "../assets/svgs/userimg.svg";
import styles from "../styles/accountPage.module.css";

const AccountPage = () => {
  return (
    <div className={styles.actWrapper}>
      <div className={styles.header}>Account overview</div>
      <img src={userimg} alt="" className={styles.userImg} />

      
      <p className={styles.actName}>Okpala Oluwayimisola</p>
      <div className={styles.actDetails}>
      
      <div className={styles.email}>Email Address</div>
      <p>oliyidekamsiyochukwu@gmail.com </p>

      <div className={styles.number}>Phone number</div>
      <p>+234 704 866 6531</p>

      <div className={styles.gender}>Gender</div>
      <p>Female</p>

      <div className={styles.dob}>Date of birth</div>
      <p>January 25, 2003</p>
      
      <button className={styles.edit}>Edit Profile</button>
      </div>
    </div>
  );
};

export default AccountPage;
